<template>
  <div class="input-password">
    <label class="label" :for="id">
      <slot></slot>
    </label>
    <div class="input--icon-wrap input--icon-locker">
      <input
        :name="name"
        :value="value"
        class="input"
        :class="{ 'input--error': hasErrors }"
        :type="passwordVisible ? `text` : `password`"
        placeholder="********"
        v-bind="$attrs"
        @input="(event) => $emit('input', event.target.value)"
        @keyup.enter="$emit('submit')"
        @paste="handlePaste"
      />
    </div>
    <span
      :class="[
        `login__toggle-password-visibility`,
        passwordVisible ? `visible` : '',
      ]"
      @mousedown="passwordVisible = true"
      @mouseup="passwordVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: "InputPassword",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    errors: {
      type: [Array, Object, String],
      default() {
        return {};
      },
    },
    preventPaste: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      passwordVisible: false,
    };
  },
  computed: {
    hasErrors() {
      if (Array.isArray(this.errors)) {
        return this.errors.length > 0;
      } else if (typeof this.errors === "object") {
        return Object.keys(this.errors).length > 0;
      } else if (typeof this.errors === "string" && this.errors) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    handlePaste(e) {
      if (!this.preventPaste) {
        this.$emit("paste", e);
        return;
      }
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
.login__toggle-password-visibility {
  position: absolute;
  content: "";
  width: 24px;
  height: 24px;
  right: 0;
  top: 30px;
  background: url("~@/images/icon-eye.svg");

  &.visible {
    background: url("~@/images/icon-view-on.svg");
    top: 31px;
  }
}
</style>
